// import Vue from 'vue';
import Fuse from 'fuse.js'

const fuseOptions = {
  includeScore: true,
  threshold: 0.2, // Adjust the fuzzy matching threshold as needed
}

export default (context, inject) => {
  const createFuseInstance = () => {
    return new Fuse([], fuseOptions)
  }

  inject('createFuse', createFuseInstance)
}
